<template>
  <div class="new-guide-step-2">
    <form-item label="待归因事件" tips="一般为广告点击、坑位点击等运营相关的事件">
      <div v-for="(localToAttributeEventItem, index) in localToAttributeEvent" :key="index" class="to-associate-item">
        <div class="to-associate-event" :class="{ 'pb-0': localToAttributeEventItem.conditionModels.length }">
          <t-select
            v-model="localToAttributeEventItem.eventName"
            placeholder="请选择"
            class="to-associate-event-select"
            :class="{ 'red-tips': equalPreEventAndToEventName(index) }"
            @change="handleEventNameChange(index)"
            filterable
          >
            <t-option
              v-for="item in eventList"
              :key="item.id"
              :label="item.eventShowName"
              :value="item.eventName"
            ></t-option>
          </t-select>
          <t-select
            v-model="localToAttributeEventItem.groupBy"
            filterable
            placeholder="请选择"
            class="to-associate-group-select"
            v-if="groupList.length > 1"
          >
            <t-option
              :label="groupItem.propertyDesc"
              :value="groupItem.propertyName"
              :key="index"
              v-for="(groupItem, index) in groupList"
            ></t-option>
          </t-select>
          <t-button
            @click="handleAddFilterItem(index)"
            class="btn-filter"
            variant="outline"
            :disabled="localToAttributeEventItem.conditionModels.length >= 5"
          >
            <icon name="add" slot="icon"></icon>
            筛选项
          </t-button>
          <icon name="delete" class="remove-btn" @click="handleDeleteToAttributeEvent(index)" />
        </div>

        <div
          class="filter"
          style="padding: 10px 0 10px 20px; background-color: #fafafa"
          v-if="localToAttributeEventItem.conditionModels.length"
        >
          <ConditionFilter
            :filter-type.sync="localToAttributeEventItem.connectors"
            :filter-list="localToAttributeEventItem.conditionModels"
            :condition-operator-options="conditionOperatorOptions"
            :condition-property-options="conditionPropertyOptions"
            :all-event-event-property-list="allEventEventPropertyList"
            :filter-events="localToAttributeEventItem.eventName"
          />
        </div>
      </div>
      <t-button
        @click="handleAddToAttributeEvent"
        class="btn-filter"
        variant="outline"
        :disabled="localToAttributeEvent.length >= 10"
      >
        <icon name="add" slot="icon"></icon>
        增加待归因事件
      </t-button>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import AssociateProperty from './associate-property.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

export default {
  name: 'to-attribute-event',
  components: {
    FormItem,
    ConditionFilter,
    AssociateProperty,
  },
  model: {
    prop: 'toAttributeEvent',
    event: 'change',
  },
  props: {
    toAttributeEvent: {
      type: Array,
      default: () => [],
    },
    preAssociatedEvent: {
      type: Array,
      default: () => [],
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localToAttributeEvent: lodash.cloneDeep(this.toAttributeEvent),
    };
  },
  computed: {
    eventNameAndShowNameMap() {
      return this.eventList.reduce((total, item) => {
        total[item.eventName] = item.eventShowName;
        return total;
      }, {});
    },
    groupList() {
      const eventPropertyOptions = lodash
        .cloneDeep(this.conditionPropertyOptions)
        .filter(item => item.propertyType === 1);
      return [
        {
          propertyType: 1,
          propertyName: '',
          propertyDesc: '不分组',
          propertyDataType: 'string',
          name: '',
          propertyValueTipVOList: [],
        },
      ].concat(eventPropertyOptions);
    },
  },
  watch: {
    toAttributeEvent: {
      handler() {
        if (JSON.stringify(this.toAttributeEvent) !== JSON.stringify(this.localToAttributeEvent)) {
          this.localToAttributeEvent = lodash.cloneDeep(this.toAttributeEvent);
        }
      },
      deep: true,
    },
    localToAttributeEvent: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localToAttributeEvent));
      },
      deep: true,
    },
  },
  methods: {
    handleEventNameChange(index) {
      const { eventName } = this.localToAttributeEvent[index];
      const eventChineseName = this.eventNameAndShowNameMap[eventName];
      this.localToAttributeEvent[index].eventChineseName = eventChineseName || '';
    },
    handleAddFilterItem(index) {
      if (this.localToAttributeEvent[index].conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localToAttributeEvent[index].conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },
    handleAddToAttributeEvent() {
      if (this.localToAttributeEvent.length >= 10) {
        this.$message.warning('最多添加10个待归因事件');
        return;
      }
      this.localToAttributeEvent.push({
        eventName: '',
        eventChineseName: '',
        groupBy: '',
        conditionModels: [],
        connectors: 'and',
      });
    },
    handleDeleteToAttributeEvent(index) {
      this.localToAttributeEvent.splice(index, 1);
    },
    equalPreEventAndToEventName(index) {
      const { eventName } = this.localToAttributeEvent[index];
      if (!eventName) {
        return false;
      }
      return !!this.preAssociatedEvent.find(item => item.eventName === eventName);
    },
  },
};
</script>

<style lang="less">
.modal {
  border-radius: 4px;

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang="less" scoped>
@import './to-attribute-event';
</style>
